module.exports = __webpack_public_path__ + "static/media/thumb-up-line.a4445958.svg";